/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserMmsiGet200ResponseRecordsInner } from './UserMmsiGet200ResponseRecordsInner';
import {
    UserMmsiGet200ResponseRecordsInnerFromJSON,
    UserMmsiGet200ResponseRecordsInnerFromJSONTyped,
    UserMmsiGet200ResponseRecordsInnerToJSON,
} from './UserMmsiGet200ResponseRecordsInner';

/**
 * 
 * @export
 * @interface UserMmsiGet200Response
 */
export interface UserMmsiGet200Response {
    /**
     * 
     * @type {Array<UserMmsiGet200ResponseRecordsInner>}
     * @memberof UserMmsiGet200Response
     */
    records?: Array<UserMmsiGet200ResponseRecordsInner>;
}

/**
 * Check if a given object implements the UserMmsiGet200Response interface.
 */
export function instanceOfUserMmsiGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserMmsiGet200ResponseFromJSON(json: any): UserMmsiGet200Response {
    return UserMmsiGet200ResponseFromJSONTyped(json, false);
}

export function UserMmsiGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMmsiGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(UserMmsiGet200ResponseRecordsInnerFromJSON)),
    };
}

export function UserMmsiGet200ResponseToJSON(value?: UserMmsiGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(UserMmsiGet200ResponseRecordsInnerToJSON)),
    };
}

